webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! T:\home\idea\study-vue-touch-ui-svg\src\main.ts */4);


/***/ }),
/* 4 */
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(/*! ./store */ 20);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    el: '#app',
    render: function (h) { return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]); }
});


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/*!*********************!*\
  !*** ./src/App.vue ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !ts-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ffa414_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-34ffa414","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 19);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-34ffa414","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 9)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ffa414_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34ffa414","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/*!************************************************************************************************************!*\
  !*** ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue ***!
  \************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FusenCanvas_vue__ = __webpack_require__(/*! ./FusenCanvas.vue */ 11);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    computed: {
        editing: function () {
            return this.$store.state.editing;
        },
        selectedItem: function () {
            return this.$store.state.items[this.$store.state.selectedIndex];
        },
        styleObj: function () {
            var selected = this.selectedItem;
            if (this.selectedItem) {
                return {
                    top: selected.y + "px",
                    left: selected.x + "px",
                    width: selected.w + "px",
                    height: selected.h + "px"
                };
            }
            return {};
        },
        editingText: {
            get: function () {
                return this.$store.state.editingText;
            },
            set: function (value) {
                this.$store.commit('updateEditor', value);
            }
        }
    },
    methods: {
        editItem: function () {
            this.$store.commit("editItem", this.editingText);
        }
    },
    components: {
        FusenCanvas: __WEBPACK_IMPORTED_MODULE_1__FusenCanvas_vue__["a" /* default */]
    },
    watch: {
        editing: function (value) {
            var _this = this;
            if (value) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                    var el = (_this.$el.querySelector(".editor__textarea"));
                    el.focus();
                });
            }
        }
    }
}));


/***/ }),
/* 11 */
/*!*****************************!*\
  !*** ./src/FusenCanvas.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FusenCanvas_vue__ = __webpack_require__(/*! !ts-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./FusenCanvas.vue */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7422ff04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FusenCanvas_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7422ff04","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./FusenCanvas.vue */ 18);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7422ff04","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./FusenCanvas.vue */ 12)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FusenCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7422ff04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FusenCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7422ff04","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/FusenCanvas.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/*!********************************************************************************************************************!*\
  !*** ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/FusenCanvas.vue ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FusenGroup_vue__ = __webpack_require__(/*! ./FusenGroup.vue */ 14);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            dragging: "none",
            resizeType: [],
            dragOffset: {
                x: 0,
                y: 0
            },
        };
    },
    computed: {
        selectedItem: function () {
            return this.$store.state.items[this.$store.state.selectedIndex];
        },
        items: function () {
            return this.$store.state.items;
        },
        handles: function () {
            var item = this.selectedItem;
            if (!item) {
                return [];
            }
            var size = 10;
            /*
              lt ct rt
              lc    rc
              lb cb rb
            */
            return [
                { type: ["left", "top"], x: 0, y: 0, size: size },
                { type: ["center", "top"], x: item.w / 2, y: 0, size: size },
                { type: ["right", "top"], x: item.w, y: 0, size: size },
                { type: ["left", "center"], x: 0, y: item.h / 2, size: size },
                { type: ["right", "center"], x: item.w, y: item.h / 2, size: size },
                { type: ["left", "bottom"], x: 0, y: item.h, size: size },
                { type: ["center", "bottom"], x: item.w / 2, y: item.h, size: size },
                { type: ["right", "bottom"], x: item.w, y: item.h, size: size },
            ];
        },
        connectorPath: function () {
            var items = this.items;
            var start = {
                x: items[0].x + items[0].w,
                y: items[0].y + items[0].h / 2,
            };
            var end = {
                x: items[1].x,
                y: items[1].y + items[1].h / 2,
            };
            var handleLength = 50;
            if (items.length > 0) {
                return "M" + start.x + "," + start.y + " C" + (start.x + handleLength) + "," + start.y + " " + (end.x - handleLength) + "," + end.y + " " + end.x + "," + end.y;
            }
            return "";
        }
    },
    methods: {
        resizePoint: function (type) {
            this.dragging = "resize";
            this.resizeType = type;
        },
        startDrag: function (ev) {
            var e = ev[0];
            var index = ev[1];
            this.dragging = "move";
            this.$store.commit("selectItem", index);
            //ページ左上とオブジェクト左上の差分から、ドラッグ開始位置（オブジェクト相対座標）を取得
            this.dragOffset.x = e.offsetX - this.selectedItem.x;
            this.dragOffset.y = e.offsetY - this.selectedItem.y;
        },
        onResize: function (e) {
            var move = {
                x: this.selectedItem.x,
                y: this.selectedItem.y,
                w: this.selectedItem.w,
                h: this.selectedItem.h
            };
            if (this.resizeType[0] === "left") {
                move.x = gridRound(e.offsetX);
                move.w = move.w - move.x + this.selectedItem.x;
            }
            if (this.resizeType[0] === "right") {
                move.w = gridRound(e.offsetX - this.selectedItem.x);
            }
            if (this.resizeType[1] === "bottom") {
                move.h = gridRound(e.offsetY - this.selectedItem.y);
            }
            if (this.resizeType[1] === "top") {
                move.y = gridRound(e.offsetY);
                move.h = move.h - move.y + this.selectedItem.y;
            }
            this.$store.commit("resizeItem", move);
        },
        onDrag: function (e) {
            if (this.dragging === "move") {
                //差分値を基点に反映
                this.$store.commit("moveItem", {
                    x: gridRound(e.offsetX - this.dragOffset.x),
                    y: gridRound(e.offsetY - this.dragOffset.y)
                });
            }
            if (this.dragging === "resize") {
                this.onResize(e);
            }
        },
        stopDrag: function () {
            if (this.dragging !== "none") {
                this.dragging = "none";
                //this.$store.commit("selectItem", -1);
            }
        },
        openEditor: function (index) {
            this.$store.commit("openEditor", index);
        }
    },
    components: {
        FusenGroup: __WEBPACK_IMPORTED_MODULE_1__FusenGroup_vue__["a" /* default */]
    }
}));
function gridRound(value) {
    return Math.round(value / 8) * 8;
}


/***/ }),
/* 14 */
/*!****************************!*\
  !*** ./src/FusenGroup.vue ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FusenGroup_vue__ = __webpack_require__(/*! !ts-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./FusenGroup.vue */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5499e54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FusenGroup_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c5499e54","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./FusenGroup.vue */ 17);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c5499e54","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./FusenGroup.vue */ 15)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FusenGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5499e54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FusenGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5499e54","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/FusenGroup.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/FusenGroup.vue ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 0);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        item: Object,
        index: Number
    },
    methods: {
        startDrag: function (event) {
            this.$emit("selected", [event, this.index]);
        },
        openEditor: function () {
            this.$emit("open", this.index);
        }
    },
    computed: {
        toPosition: function () {
            return "translate(" + this.item.x + ", " + this.item.y + ")";
        }
    }
}));


/***/ }),
/* 17 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5499e54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/FusenGroup.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":_vm.toPosition}},[_c('rect',{staticClass:"item",attrs:{"width":_vm.item.w,"height":_vm.item.h,"filter":"url(#drop-shadow)"},on:{"pointerdown":function($event){_vm.startDrag($event)},"dblclick":_vm.openEditor}}),_vm._v(" "),_c('foreignObject',{attrs:{"width":"300","height":"300","x":"0","y":"0"}},[_c('div',{staticClass:"innerText",domProps:{"textContent":_vm._s(_vm.item.text)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 18 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7422ff04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/FusenCanvas.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"canv","width":"800","height":"800"},on:{"pointermove":_vm.onDrag,"pointerup":_vm.stopDrag}},[_c('filter',{attrs:{"id":"drop-shadow","width":"150%","height":"150%"}},[_c('feGaussianBlur',{attrs:{"in":"SourceAlpha","result":"blur","stdDeviation":"2"}}),_vm._v(" "),_c('feOffset',{attrs:{"result":"offsetBlur","dx":"2","dy":"2"}}),_vm._v(" "),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"offsetBlur","mode":"normal"}})],1),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('fusen-group',{key:index,attrs:{"index":index,"item":item},on:{"selected":_vm.startDrag,"open":_vm.openEditor}})}),_vm._v(" "),(_vm.selectedItem)?_c('g',{attrs:{"transform":'translate('+ _vm.selectedItem.x + ',' + _vm.selectedItem.y +  ')'}},[_c('rect',{staticClass:"selection",attrs:{"x":0,"y":0,"width":_vm.selectedItem.w,"height":_vm.selectedItem.h}}),_vm._v(" "),_vm._l((_vm.handles),function(handle,index){return _c('rect',{key:index,staticClass:"handle",attrs:{"x":handle.x - handle.size / 2,"y":handle.y - handle.size / 2,"width":handle.size,"height":handle.size},on:{"pointerdown":function($event){_vm.resizePoint(handle.type)}}})})],2):_vm._e(),_vm._v(" "),_c('path',{staticClass:"connector",attrs:{"d":_vm.connectorPath}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ffa414","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.0.0-beta/css/bootstrap-reboot.css"}}),_vm._v(" "),_c('fusen-canvas'),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"editor"},[_c('div',{staticClass:"editor__frame",style:(_vm.styleObj)},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingText),expression:"editingText"}],staticClass:"editor__textarea",attrs:{"autofocus":""},domProps:{"value":(_vm.editingText)},on:{"blur":_vm.editItem,"input":function($event){if($event.target.composing){ return; }_vm.editingText=$event.target.value}}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 20 */
/*!**********************!*\
  !*** ./src/store.ts ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 21);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        selectedIndex: -1,
        editingText: "",
        items: [
            {
                x: 10,
                y: 10,
                w: 200,
                h: 100,
                text: "Hello\nWorld"
            },
            {
                x: 210,
                y: 210,
                w: 300,
                h: 150,
                text: "はろー"
            }
        ],
        editing: false
    },
    mutations: {
        moveItem: function (state, payload) {
            state.items[state.selectedIndex].x = payload.x;
            state.items[state.selectedIndex].y = payload.y;
        },
        resizeItem: function (state, payload) {
            state.items[state.selectedIndex].x = payload.x;
            state.items[state.selectedIndex].y = payload.y;
            state.items[state.selectedIndex].w = payload.w;
            state.items[state.selectedIndex].h = payload.h;
        },
        selectItem: function (state, index) {
            state.selectedIndex = index;
        },
        openEditor: function (state, index) {
            state.editing = true;
            state.selectedIndex = index;
            state.editingText = state.items[index].text;
        },
        editItem: function (state, text) {
            state.items[state.selectedIndex].text = text;
            state.editingText = "";
            state.editing = false;
        },
        updateEditor: function (state, value) {
            state.editingText = value;
        }
    }
}));


/***/ })
],[3]);


// WEBPACK FOOTER //
// client.c35e3c27.js